import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsArkecosystemComponent } from './simple-icons-arkecosystem.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsArkecosystemComponent ],
    exports:      [ SimpleIconsArkecosystemComponent ],
    bootstrap:    []
})
export class SimpleIconsArkecosystemModule {}
